import { useEffect } from "react";

export default function Toast({ message, type = "success", onClose }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [message]);

  if (!message) return null;

  const colors = {
    success: { bg: "rgba(76,175,80,0.15)", border: "rgba(76,175,80,0.4)", color: "#4caf50", icon: "✅" },
    error:   { bg: "rgba(233,69,96,0.15)", border: "rgba(233,69,96,0.4)", color: "#e94560", icon: "❌" },
    info:    { bg: "rgba(79,195,247,0.15)", border: "rgba(79,195,247,0.4)", color: "#4fc3f7", icon: "ℹ️" },
    warning: { bg: "rgba(255,152,0,0.15)", border: "rgba(255,152,0,0.4)", color: "#ff9800", icon: "⚠️" },
  };

  const c = colors[type] || colors.success;

  return (
    <div style={{
      position: "fixed", bottom: "90px", left: "50%",
      transform: "translateX(-50%)",
      background: c.bg, border: `1px solid ${c.border}`,
      color: c.color, padding: "12px 20px",
      borderRadius: "12px", fontSize: "14px",
      fontWeight: "600", zIndex: 9999,
      boxShadow: "0 8px 30px rgba(0,0,0,0.4)",
      display: "flex", alignItems: "center", gap: "8px",
      whiteSpace: "nowrap", maxWidth: "90vw",
      animation: "fadeIn 0.3s ease",
    }}>
      <span>{c.icon}</span>
      <span>{message}</span>
      <button onClick={onClose} style={{
        background: "none", border: "none",
        color: c.color, cursor: "pointer",
        fontSize: "16px", marginLeft: "8px",
        padding: 0, lineHeight: 1,
      }}>✕</button>
    </div>
  );
}